import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'

// import './registerServiceWorker'
import i18n from './plugins/i18n.plugin'
import HelpersPlugin from './plugins/helpers.plugin'
import detectOutside from './plugins/detectOutside.plugin'
import ApiPlugin from './plugins/api.plugin';

import ServicePlugin from './plugins/service.plugin';


Vue.config.productionTip = false;

Vue.use(HelpersPlugin)
Vue.use(detectOutside)
Vue.use(ApiPlugin)
Vue.use(ServicePlugin, router);

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
